export const COUPON_EVENTS = {
  COUPON_PAGE_LOADS: 'coupon_page_loads',
  COUPON_COLLECTED: 'coupon_collected',
  COUPON_SEE_DETAILS_CLICKED: 'coupon_see_details_click',
  OFFERS_SEE_DETAILS_CLICKED: 'offers_see_details_click',
  COUPON_SHOP_MORE_CLICKED: 'coupon_shop_more_click',
  OFFERS_SHOP_MORE_CLICKED: 'offers_shop_more_click',
  COUPON_COPY_CODE_CLICKED: 'coupon_copy_code_click',
  OFFER_LISTING_LOADS: 'offer_listing_page_loads',
  COUPON_REMOVED: 'coupon_removed',
  COUPON_APPLY_FAILURE: 'cart_coupon_apply_failure',
};
